export enum NewrelicEvent {
  GOOGLE_CONSENT = "google_consent",
  MANUAL_UPLOAD = "manual_upload",
}

export const NewrelicEventTypes = {
  [NewrelicEvent.GOOGLE_CONSENT]: {
    GOOGLE_GIVE_CLICK: "consent_click",
    GOOGLE_REDIRECT_PAGE_LOAD: "consent_page_load",
    GOOGLE_REDIRECT_PAGE_HIT: "consent_page_server_hit",
    POLLING_STATUS: "polling_status",
    CLOSE_SAFARICHROME_TAB_TRIGERRED:"close_safari_chrom_tab",
    AUTO_CLOSE_SAFARICCHROME_TAB: "auto_close_safari_chrome_tab",
    CONSENT_RESPONSE: "consent_response",
    USER_CANCELLED_LINKING: "user_cancelled_linking",
  },
  [NewrelicEvent.MANUAL_UPLOAD]:{
    UPLOAD_SUCCESS: "upload_success",
  }
};
